/**
 * @generated SignedSource<<433903d6dfe6235d7f3e7d5f6bb21383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespHeroCarousel_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useItemMediaItems_viewer">;
  readonly " $fragmentType": "PdpRespHeroCarousel_viewer";
};
export type PdpRespHeroCarousel_viewer$key = {
  readonly " $data"?: PdpRespHeroCarousel_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespHeroCarousel_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespHeroCarousel_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useItemMediaItems_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6b6c940d19afdc00b82aaf03f769b81b";

export default node;
